import React, { ReactElement } from 'react';
import { SyfLogoInterface } from '../../interfaces/SyfLogo.interface';
import { setImagePath } from '../../utils/helpers';

const SyfLogo = ({ syfLogoClass, altText }: SyfLogoInterface): ReactElement => {
  const url = setImagePath('syf-logo');
  return (
    <img
      className={syfLogoClass}
      data-testid="img-syf-logo"
      src={url}
      alt={altText}
    />
  );
};

export default SyfLogo;
